import {
  AGE_ACQUISITION_FREE_START_AND_END_DATE_SELECTION,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useSearchFormFreeDateSelection(
  searchFormClicked: boolean,
): boolean {
  const decision = useSpecificOptimizelyUserDecision(
    AGE_ACQUISITION_FREE_START_AND_END_DATE_SELECTION,
    searchFormClicked,
  )
  return decision?.variationKey === OPTIMIZELY_VARIANT_KEYS.FREE_DATE_SELECTION
}
